import * as React from 'react'
import {Component} from "../Utils"
import {sumBy, indexOf} from 'lodash'
import {findIndex, isUndefined, isEmpty} from 'lodash';
import { ActionsDefaultState, ActionsRules } from '../../const/action_rules';
import {URL_PREFIX} from "../../const/forms";

interface ActionsProps {
  schema: any;
  mode:string;
  progress: number;
  form_type: string;
  userRole: string;
  process_id: number;
  isVisible: boolean;
  status: number;
  isPdf: boolean;
  formKind?: number;
  onSend: () => void;
  onPDF: () => void;
  onDraft: () => void;
  //onDocument: (comment?: boolean, personal?: boolean, title?: string) => void;
  onDocument: (...args: any) => void;
  onRevoke: (comment?: boolean, personal?: boolean, title?: string) => void;
  onReturn: ({ customLink, formKind }: { customLink?: string, formKind?: number }) => void;
  onDelete: () => void;
  onCopy: (lastComment?: string) => void;
  onLastComment: (lastComment?: string, lastCommentColor?: string) => void;
  onAddition: () => void;
}

interface ActionState{
  send: string;
  revoke: string;
  comment: any;
  visible: string[];
  lastComment?: string;
  lastCommentColor?: string;
  showOnLoad?: boolean;
  revokeColor?: string;
}

function getCountRequired(sections: Array<any>, checkPanel: Array<string>) {
  let count = 0;
  for (let section of sections) {
    count += getCountRequiredInSection(section.controls, checkPanel);
  }

  return count;
}

function getCountRequiredInSection(controls: Array<any>, checkPanel: Array<string>) {
  for (let ctrl of controls) {
    if (ctrl.type.toUpperCase() !== 'PANEL' && ctrl.required) {
      return 1;
    } else if (indexOf(checkPanel, ctrl.id) > -1) {
      return getCountRequiredInSection(ctrl.controls, checkPanel);
    }
  }

  return 0;
}

export default class Actions extends Component<ActionsProps, ActionState> {
  constructor() {
    super();
    this.state = {
      ...ActionsDefaultState
    };
    this.setStatus = this.setStatus.bind(this);
  }

  componentDidMount(): void {
    this.setStatus();
  }

  componentDidUpdate(prevProps: Readonly<ActionsProps>, prevState: Readonly<ActionState>, prevContext: any): void {
    const { status, userRole } = this.props;

    if (prevProps.status !== status || prevProps.userRole !== userRole) {
      this.setStatus()
    }
  }

  setStatus() {
    const { status, userRole } = this.props;
    if (!isUndefined(ActionsRules[userRole]) && !isUndefined(ActionsRules[userRole][status])) {
      const initialState = { ...ActionsRules[userRole][status] };
      this.setState({ ...initialState });
    } else {
      this.setState({ ...ActionsRules.user['7']})
    }
  }

  render() {
    const { mode, formKind } = this.props;
    const { send, revoke, visible, comment, lastComment, lastCommentColor, revokeColor } = this.state;
    const returnUrl = `${URL_PREFIX}/${formKind ? 'investors' : 'expertise'}`;

    return (
      <div className="reportbox-actions">
        <div className="note">
          {mode === 'suspended' && <span style={{color: 'red'}}>Приём заявок временно приостановлен</span> }
          {mode === 'working' && <span>Данные заявки сохраняются автоматически</span> }
        </div>
        <div className="btn-content">
          <button className="btn btn-backbutton btn-sm pull-right" onClick={() => this.props.onReturn({ customLink: returnUrl, formKind })}>
            Назад к списку заявок
          </button>
          {lastComment && (
            <button className="btn btn-sm pull-right btn-primary" onClick={this.props.onLastComment.bind(this, lastComment, lastCommentColor)} style={lastCommentColor ? { backgroundColor: lastCommentColor, borderColor: lastCommentColor } : {}}>
              {lastComment}
            </button>
          )}
          {( (visible.indexOf('revoke') > -1) ) && (
            <button
              className="btn btn-sm btn-bordered pull-right"
              onClick={this.props.onRevoke.bind(this, visible.indexOf('comment/revoke') > -1, visible.indexOf('personal/revoke') > -1, isUndefined(comment.revoke) ? comment : comment.revoke)}
              style={revokeColor ? { backgroundColor: revokeColor, borderColor: revokeColor } : {}}
            >
              {revoke}
            </button>
          )}
          {visible.indexOf('send') > -1 && (
            <button
              className="btn btn-success btn-sm pull-right"
              onClick={() => {
                this.props.onDocument({
                  title: isUndefined(comment.send) ? comment : comment.send,
                  returnUrl,
                  formKind,
                })
              }}
            >
              {send}
            </button>
          )}
        </div>
      </div>
    )
  }
}
